import script from "./ChatChildView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatChildView.vue?vue&type=script&setup=true&lang=ts"

import "./ChatChildView.vue?vue&type=style&index=0&id=8706cb3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8706cb3a"]])

export default __exports__